import { IonRangeSliderEvent, IonRangeSliderOptions } from "ion-rangeslider";
import { AxInit, ModuleName } from "../../Lib/AxSystem/AxInit";
import { RetailItem, RetailItemVariant } from "../../Models/Retail/RetailItem";
import { AxLimeStone } from "../../Limestone/AxLimeStone";
import { AxLoading } from "../../Limestone/AxLoading/AxLoading";
import { retailHelper } from "../../Lib/Helper/Retail/RetailHelper";
import { BodyUtility } from "../../Components/AxUtility/BodyUtility";
import { LocalStorageKeyCollection } from "../../Lib/Constants/KeyCollection/LocalStorageKeyCollection";

@ModuleName("RetailFilter")
export class RetailFilter implements AxInit {
    private rangeSlider: any;
    private priceRangeMin: number;
    private priceRangeMax: number;
    private currencyString: string;
    private retailItems: RetailItem[];
    private globalVariants: RetailItemVariant[] = [];
    private groupID: number;

    constructor(private _retailHelper = new retailHelper(),
        private _axLoading = new AxLoading(),
        private _bodyUtility = new BodyUtility()) { }

    private multiSelectFilter: RetailItemVariant[] = [];
    private tmpFilter: RetailItemVariant[];

    AxInit(init: RetailFilterInit): void {
        this.retailItems = init.RetailItems;
        this.currencyString = init.CurrencyString;
        this.groupID = init.GroupID;
        this.mergeVariants();

        this.setSizeValues();
        this.setMultiSelectFilter();
        this.setChipFilter();
        this.setColorPicker();
        this.setPriceFilter();

        this.assignResetEvent();
        this.setFilterCount();

        this._retailHelper.checkReload(x => {
            this.loadFilterFromLocalStorage(x);
        }, this.groupID);

        $('.retail__filter_settings').click(e => {
            window.scrollTo(0, 0);
            this.tmpFilter = this.multiSelectFilter.slice();
            $('.prod_selection__prod-wrapper').addClass('active');
            this._bodyUtility.DisableScroll();
        });


        $('.prod_selection__prod-wrapper .retail__filter_settings-close').click(e => {
            this.multiSelectFilter = this.tmpFilter;

            for (let gVariant of this.globalVariants.filter(x => !this.containsFilter(x, this.tmpFilter))) {
                this.toggleFilter(gVariant, false);
            }
            for (let tVariant of this.tmpFilter) {
                this.toggleFilter(tVariant, true);
            }
            if (typeof this.rangeSlider != 'undefined') {
                //This triggers update, keep it last!
                this.rangeSlider.update({
                    from: this.rangeSlider.options.min,
                    to: this.rangeSlider.options.max
                });
            } else {
                this.updateFilteredProducts();
            }

            $('.prod_selection__prod-wrapper').removeClass('active');

            this._bodyUtility.EnableScroll();
        });

        $('.retail__filter-update').click(e => {
            $('.prod_selection__prod-wrapper').removeClass('active');
            this._bodyUtility.EnableScroll();

        });

        $('.retail__filter-resetAllFilter').click(e => {
            for (let tmp of this.multiSelectFilter) {
                this.toggleFilter(tmp, false);
            }
            this.multiSelectFilter = [];

            if (typeof this.rangeSlider != 'undefined') {
                //This triggers update, keep it last!
                this.rangeSlider.update({
                    from: this.rangeSlider.options.min,
                    to: this.rangeSlider.options.max
                });
            } else {
                this.updateFilteredProducts();
            }
        });
    }


    loadFilterFromLocalStorage(storageFilter: RetailItemVariant[]) {
        if (storageFilter != null && storageFilter.length > 0) {
            this.multiSelectFilter = [];

            for (let filter of storageFilter) {
                if ($(`.retail__filter-container[data-filterType="${filter.FeatureType}"][data-filterName="${filter.FeatureName}"][value="${filter.FeatureValue}"]`).length > 0) {
                    this.toggleFilter(filter, true);
                    this.multiSelectFilter.push(filter);
                }
            }

            if (this.multiSelectFilter.length > 0) {
                this.updateFilteredProducts();
            }
        }
    }

    setFilterCount() {
        let groupedFilter = this.globalVariants.reduce((r, a) => {
            let key = `${a.FeatureType}-${a.FeatureName}`;
            r[key] = r[key] || [];
            r[key].push(a);
            return r;
        }, Object.create(null));


        for (let group of Object.keys(groupedFilter)) {
            let sampleVariant: RetailItemVariant = groupedFilter[group][0];
            let availableItems = this.getFilteredList(this.multiSelectFilter.filter(
                x => x.FeatureName !== sampleVariant.FeatureName || x.FeatureType !== sampleVariant.FeatureType)).filter(x => x.IsMaster);
            let anyElementActive = false;

            let priceMinFilterChanged = this.rangeSlider != null ? this.rangeSlider.options.min !== this.rangeSlider.old_from : false;
            let priceMaxFilterChanged = this.rangeSlider != null ? this.rangeSlider.options.max !== this.rangeSlider.old_to : false;


            for (let variant of groupedFilter[group]) {
                let itemsWithVariant = availableItems.filter(y => y.Variants.findIndex(x => x.FeatureName === variant.FeatureName &&
                    x.FeatureType === variant.FeatureType &&
                    x.FeatureValue === variant.FeatureValue) !== -1 && ((y.Tariff <= this.priceRangeMax || !priceMaxFilterChanged) && (y.Tariff >= this.priceRangeMin || !priceMinFilterChanged)));
                let $container =
                    $(`.retail__filter-container[data-filterType="${sampleVariant.FeatureType}"][data-filterName="${sampleVariant.FeatureName}"][value="${variant.FeatureValue}"]`);
                let elementActive = itemsWithVariant.length > 0 || $container.hasClass('active');
                anyElementActive = anyElementActive || elementActive;
                $container.toggleClass('d-none', !elementActive);

                $(`.retail__filter-container[data-filterType="${sampleVariant.FeatureType}"][data-filterName="${sampleVariant.FeatureName}"][value="${variant.FeatureValue}"] .retail__filter_count`)
                    .html(`(${itemsWithVariant.length})`);
            }

            $(`.retail__filter-block[data-filterType="${sampleVariant.FeatureType}"][data-filterName="${sampleVariant
                .FeatureName}"]`).toggleClass('d-none', !anyElementActive);
        }
    }

    assignResetEvent() {
        $('.retail__filter_reset').click(e => {
            let $e = $(e.delegateTarget);
            let featureType = parseInt($e.attr('data-filterType') as string);
            let featureName = $e.attr('data-filterName') as string;

            this.toggleFilterByType(featureType, featureName, false);
            this.multiSelectFilter =
                this.multiSelectFilter.filter(
                    x => x.FeatureType !== featureType || x.FeatureName !== featureName);
            this.updateFilteredProducts();
        });
    }

    getFilteredList(filterList: RetailItemVariant[]): RetailItem[] {
        let filteredItems: RetailItem[] = [];

        let multiSelectFilter = filterList.filter(x => this.isMultiSelectFilter(x));
        if (multiSelectFilter.length > 0) {
            let baseList = this.retailItems;

            let groupedFilter = multiSelectFilter.reduce((r, a) => {
                let key = `${a.FeatureType}-${a.FeatureName}`;
                r[key] = r[key] || [];
                r[key].push(a);
                return r;
            }, Object.create(null));

            for (let group of Object.keys(groupedFilter)) {
                filteredItems = [];
                for (let filter of groupedFilter[group]) {
                    filteredItems.push(...baseList.filter(x => x.Variants != null &&
                        x.Variants.findIndex(y => y.FeatureName === filter.FeatureName &&
                            y.FeatureValue === filter.FeatureValue &&
                            y.FeatureType === filter.FeatureType) !==
                        -1));
                }
                baseList = filteredItems;
            }
        } else {
            filteredItems = this.retailItems;
        }

        let chipFilter = filterList.filter(x => !this.isMultiSelectFilter(x));
        if (chipFilter.length > 0) {
            for (let filter of chipFilter) {
                filteredItems = filteredItems.filter(x => x.Variants != null &&
                    x.Variants.findIndex(y => y.FeatureName === filter.FeatureName &&
                        y.FeatureValue === filter.FeatureValue &&
                        y.FeatureType === filter.FeatureType) !==
                    -1);
            }
        }

        return filteredItems;
    }

    updateFilteredProducts(): void {
        //300ms loading
        this._axLoading.ShowLoadingIndicator($('.retail__filter_bar')[0], true);
        $('.retail__filter_bar--container').addClass('loading');

        setTimeout(() => {
            let filteredItems: RetailItem[] = this.getFilteredList(this.multiSelectFilter);
            let priceFilteredItems =
                filteredItems.filter(y => y.Tariff <= this.priceRangeMax && y.Tariff >= this.priceRangeMin);

            this.updatePriceFilter(filteredItems);

            $('.retail__filter_item').removeClass('d-none');

            for (let item of this.retailItems.filter(x => priceFilteredItems.findIndex(y => y.RetailItemNr === x.RetailItemNr) === -1)) {
                $(`.retail__filter_item[data-itemid=${item.RetailItemNr}]`).addClass('d-none');
            }

            let entriesLeft: boolean = $('.retail__filter_item').not('.d-none').length !== 0;
            $('.retail__notFound').toggleClass('d-none', entriesLeft);

            if (entriesLeft) {
                this._retailHelper.saveToLocalStorage(this.multiSelectFilter, this.groupID);
                $('.retail__filter_settings').toggleClass('hideCount', this.multiSelectFilter.length == 0).attr('data-count', this.multiSelectFilter.length);
            }

            this.setFilterCount();

            this._axLoading.HideLoadingIndicator($('.retail__filter_bar')[0]);
            $('.retail__filter_bar--container').removeClass('loading');
        }, 300);
    }

    setColorPicker() {
        this._retailHelper.setColorPickerColors($('.retail__filter_color'));

        $('.retail__filter_color-btn').click(e => {
            let $e = $(e.delegateTarget);
            let $container = $e.parent();
            let filter = this.getFilterFromElement($container);

            $e.toggleClass('active');

            this.setActiveContainer($container, $e.hasClass('active'));
            if ($e.hasClass('active')) {
                this.multiSelectFilter.push(filter);
            } else {
                this.multiSelectFilter =
                    this.multiSelectFilter.filter(x => x.FeatureType !== filter.FeatureType || x.FeatureName !== filter.FeatureName || x.FeatureValue !== filter.FeatureValue);
            }
            this.updateFilteredProducts();
        });
    }


    setPriceFilter() {
        let min = this.retailItems.reduce((prev, curr) => prev.Tariff < curr.Tariff ? prev : curr).Tariff;
        let max = this.retailItems.reduce((prev, curr) => prev.Tariff > curr.Tariff ? prev : curr).Tariff;

        this.priceRangeMin = min;
        this.priceRangeMax = max;

        if (min !== max) {
            $("#retail__filter__price_slider").ionRangeSlider({
                skin: 'round',
                type: 'double',
                hide_min_max: true,
                extra_classes: 'ax-range-slider has-labels',
                prefix: `${this.currencyString} `,
                max: max / 100,
                min: min / 100,
                drag_interval: true,
                onStart: x => {
                    this.currentFilterList = this.getFilteredList(this.multiSelectFilter);
                },
                onFinish: x => this.priceSliderChange(x),
                onUpdate: x => this.priceSliderChange(x),
                onChange: x => this.backgroundUpdatePriceFilter(x)
            });
            this.rangeSlider = $("#retail__filter__price_slider").data("ionRangeSlider");

            $('.retail__filter__price_reset').click(x => {
                this.rangeSlider.update({
                    from: this.rangeSlider.options.min,
                    to: this.rangeSlider.options.max
                });
            });
        } else {
            $('.retail__filter__price_holder').addClass('d-none');
        }
    }

    priceSliderChange(x: IonRangeSliderEvent) {
        this.priceRangeMin = Math.round(x.from * 100);
        this.priceRangeMax = Math.round(x.to * 100);
        this.updateFilteredProducts();

        let priceFilteredItems = this.currentFilterList.filter(y => y.Tariff <= Math.round(x.to * 100) && y.Tariff >= Math.round(x.from * 100));

        if (priceFilteredItems.length > 0) {
            let min = priceFilteredItems.reduce((prev, curr) => prev.Tariff < curr.Tariff ? prev : curr).Tariff;
            let max = priceFilteredItems.reduce((prev, curr) => prev.Tariff > curr.Tariff ? prev : curr).Tariff;

            if (min !== max) {
                this.updatePriceFilterSingleItem(0);
            }
        }
    }

    private currentFilterList: RetailItem[];

    backgroundUpdatePriceFilter(event: IonRangeSliderEvent) {
        let priceFilteredItems = this.currentFilterList.filter(y => y.Tariff <= Math.round(event.to * 100) && y.Tariff >= Math.round(event.from * 100));

        if (priceFilteredItems.length > 0) {
            let min = priceFilteredItems.reduce((prev, curr) => prev.Tariff < curr.Tariff ? prev : curr).Tariff;
            let max = priceFilteredItems.reduce((prev, curr) => prev.Tariff > curr.Tariff ? prev : curr).Tariff;

            if (min === max) {
                this.updatePriceFilterSingleItem(priceFilteredItems[0].Tariff);
            }
        }
    }

    private lastPriceFilterTariff: number = 0;

    updatePriceFilterSingleItem(tariff: number) {
        if (tariff !== this.lastPriceFilterTariff) {
            this.lastPriceFilterTariff = tariff;
            if (tariff !== 0) {
                this.rangeSlider.update({
                    from_max: tariff / 100,
                    to_min: tariff / 100
                });
            } else {
                this.rangeSlider.update({
                    from_max: null,
                    to_min: null
                });
            }
        }
    }

    updatePriceFilter(itemList: RetailItem[]) {
        let rangeSliderExist = typeof this.rangeSlider != 'undefined';

        if (rangeSliderExist) {
            let oldMin = this.rangeSlider.options.min;
            let oldMax = this.rangeSlider.options.max;

            let min = 0;
            let max = 0;

            if (itemList.length > 0) {
                min = itemList.reduce((prev, curr) => prev.Tariff < curr.Tariff ? prev : curr).Tariff / 100;
                max = itemList.reduce((prev, curr) => prev.Tariff > curr.Tariff ? prev : curr).Tariff / 100;
            }

            let oldFrom = this.rangeSlider.old_from;
            let oldTo = this.rangeSlider.old_to;
            let from = oldFrom > min && oldFrom !== oldMin ? oldFrom : min;
            let to = oldTo < max && oldTo !== oldMax ? oldTo : max;

            if (min !== oldMin || max !== oldMax) {
                this.rangeSlider.update({
                    min: min,
                    max: max,
                    from: from,
                    to: to
                });
            }
        }
    }

    setChipFilter() {
        $('button.ax-chip.retail__filter-chips').click(e => {
            let $target = $(e.delegateTarget);
            let $container = $target.parent();
            let filter = this.getFilterFromElement($container);

            $container.parent().find('button.ax-chip.retail__filter-chips.active').each((i, siblings) => {
                this.toggleChip($(siblings));
            });

            this.toggleChip($target);

            this.multiSelectFilter = this.multiSelectFilter.filter(x => x.FeatureType !== filter.FeatureType || x.FeatureName !== filter.FeatureName);
            if ($target.hasClass('active')) {
                this.multiSelectFilter.push({
                    FeatureType: filter.FeatureType,
                    FeatureValue: filter.FeatureValue,
                    FeatureName: filter.FeatureName,
                    VariantRelated: false,
                    Color: filter.Color
                });
            }

            this.updateFilteredProducts();
        });
    }

    setMultiSelectFilter() {
        $('.retail__filter-multiselect').change(x => {
            let $e = $(x.delegateTarget);
            let $container = $e.parent().parent();

            let filter = this.getFilterFromElement($container);
            this.setActiveContainer($container, $e.prop('checked'));

            if ($e.prop('checked')) {
                this.multiSelectFilter.push({
                    FeatureType: filter.FeatureType,
                    FeatureValue: filter.FeatureValue,
                    FeatureName: filter.FeatureName,
                    VariantRelated: false,
                    Color: filter.Color
                });
            } else {
                this.multiSelectFilter = this.multiSelectFilter.filter(x => x.FeatureType !== filter.FeatureType ||
                    x.FeatureValue !== filter.FeatureValue ||
                    x.FeatureName !== filter.FeatureName);
            }

            this.updateFilteredProducts();
        });
    }

    containsFilter(searchValue: RetailItemVariant, list: RetailItemVariant[]) {
        return list.findIndex(x => x.FeatureType === searchValue.FeatureType &&
            x.FeatureName === searchValue.FeatureName &&
            x.FeatureValue === searchValue.FeatureValue) !==
            -1;
    }

    setActiveContainer($e: JQuery<Element>, toggleValue: boolean) {
        $e.toggleClass('active', toggleValue);
    }

    getFilterFromElement($e: JQuery<HTMLElement>): RetailItemVariant {
        return {
            FeatureType: parseInt($e.attr('data-filterType') as string),
            FeatureValue: $e.attr('value') as string,
            FeatureName: $e.attr('data-filterName') as string,
            VariantRelated: false,
            Color: $e.css('background-color')
        };
    }

    toggleChip($target: JQuery<HTMLElement>) {
        $target.toggleClass('active').toggleClass('ax-fill-primary');
    }

    setSizeValues() {
        for (let item of this.retailItems.filter(x => x.Variants != null &&
            x.Variants.findIndex(y => y.FeatureType === 6) !== -1)) {
            let size = item.Variants.filter(x => x.FeatureType === 6).map(x => x.FeatureValue).join(" ");
            $(`.retail__filter_item[data-itemid=${item.RetailItemNr}] .retail__filter_item_size`).html(size);
        }
    }

    toggleFilterByType(featureType: number, featureName: string, state: boolean) {
        switch (featureType) {
            case 6:
                $(`.retail__filter-container[data-filterType="${featureType}"][data-filterName="${featureName}"] button.retail__filter-chips.ax-chip.retail__filter-chips`).each((i, x) => {
                    let $x = $(x);
                    $x.toggleClass('active', state).toggleClass('ax-fill-primary', state);
                });
                break;

            case 2:
                for (let x of $('.retail__filter_color-btn')) {
                    let $x = $(x);
                    $x.toggleClass('active', state);
                }
                break;

            default:
                $(`.retail__filter-container[data-filterType="${featureType}"][data-filterName="${featureName}"] .retail__filter-multiselect`)
                    .prop('checked', state);
                break;
        }
    }

    toggleFilter(variant: RetailItemVariant, state: boolean) {
        switch (variant.FeatureType) {
            case 6:
                $(`.retail__filter-container[data-filterType="${variant.FeatureType}"][data-filterName="${variant.FeatureName}"][value="${variant.FeatureValue}"] button.retail__filter-chips.ax-chip.retail__filter-chips`).toggleClass('active', state).toggleClass('ax-fill-primary', state);
                break;

            case 2:
                $(`.retail__filter-container[data-filterType="${variant.FeatureType}"][data-filterName="${variant.FeatureName}"][value="${variant.FeatureValue}"] .retail__filter_color-btn`).toggleClass('active', state);
                break;

            default:
                $(`.retail__filter-container[data-filterType="${variant.FeatureType}"][data-filterName="${variant.FeatureName}"][value="${variant.FeatureValue}"] .retail__filter-multiselect`).prop('checked', state);
                break;
        }
    }

    mergeVariants() {
        for (let item of this.retailItems.filter(x => !x.IsMaster && x.AvailableItems > 0)) {
            let mainItem = this.retailItems.find(x => x.RetailNr === item.RetailParentNr);

            if (mainItem.AvailableItems === 0) {
                mainItem.Variants = [];
            }

            if (mainItem.Variants != null) {
                mainItem.Variants.push(...item.Variants.filter(x => mainItem.Variants.findIndex(y => y.FeatureType === x.FeatureType && y.FeatureName === x.FeatureName && x.FeatureValue === y.FeatureValue) === -1));
            } else {
                mainItem.Variants = item.Variants;
            }
        }
        this.setGlobalVariant();
    }

    setGlobalVariant() {
        for (let item of this.retailItems.filter(x => x.IsMaster)) {
            this.globalVariants.push(...item.Variants.filter(x => this.globalVariants.findIndex(y => y.FeatureType === x.FeatureType && y.FeatureName === x.FeatureName && x.FeatureValue === y.FeatureValue) === -1));
        }
    }

    isMultiSelectFilter(variant: RetailItemVariant): boolean {
        return variant.FeatureType !== 6;
    }
}

interface RetailFilterInit {
    CurrencyString: string;
    RetailItems: RetailItem[];
    GroupID: number;
}